import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
    DialogTitle
} from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import '@/component/supportIframe/DialogConfirmPassword.css';
import { getPublicAPI } from '@/service/publicService';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';

export const DialogConfirmPassword = props => {
    const isOpen = props?.showDialog?.isOpen;
    const inputEmail = props?.showDialog.formDataTranfer?.mailAddress;
    const [showError, setShowError] = useState(false);
    const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);
    const [inputPassword, setInputPassword] = useState();

    const handleClose = () => {
        props.setShowDialog(prev => ({ ...prev, isOpen: false }));
        setShowError(false);
    };

    const handleSubmitLogin = async () => {
        if (inputPassword.length < 8) {
            setShowError(true);
        } else {
            setIsLoadingConfirm(true);
            try {
                let formDataTransfer = props?.showDialog.formDataTranfer;
                let formData = props?.showDialog.formData;
                let infoB2CInCorp = props?.showDialog.infoB2CInCorp;

                const paramsCreatAnonymous = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.VERIFY_CONFIRM_TICKET_ANONYMOUS_QA,
                    corporationId:props?.affiliationOrganization,
                    emailB2C: infoB2CInCorp.mail,
                    projectId: props?.projectId
                };
    
                let results = await getPublicAPI(props?.API, paramsCreatAnonymous);
                let infoBC2InCorp = {};
                let listB2CInProj = [];
                if (results.success) {
                    let payloads = Utils.convertJSONDataToObject(results.payload);
                    infoBC2InCorp = payloads.infoBC2InCorp;
                    listB2CInProj = payloads.listB2CInProj;
                }

                let infoB2CInProj = listB2CInProj.find(item => {
                    return item.id === infoBC2InCorp.id;
                });

                if(Utils.isEmptyObject(infoB2CInProj) || infoB2CInProj.activeInProject === Constant.ACTIVE_FLAG.DELETED) {
                    setShowError(false);
                    props.handleSubmitCreateTicket(formDataTransfer, formData, true, infoBC2InCorp);
                    return;
                }

                const verifyPasswordParams = {
                    B2CMail: infoB2CInCorp.mail + '_' +props?.affiliationOrganization,
                    B2CPassword: inputPassword,
                    getApiType: Constant.GET_API_PUBLIC_TYPE.VERIFY_B2C_PASSWORD,
                }
                const verifyResult = await getPublicAPI(props?.API, verifyPasswordParams);
                if (verifyResult.success) {
                    props.verifyPassword(formDataTransfer, formData, infoB2CInCorp);
                    setShowError(false);
                    // handleClose();
                } else {
                    setShowError(true)
                    setIsLoadingConfirm(false);
                }
            } catch (err) {
                setShowError(true);
                setIsLoadingConfirm(false);
            }
        }
    };

    useEffect(() => {
        const listener = async event => {
            if (event.code === 'Enter' || event.code === 'NumpadEnter') {
                await handleSubmitLogin();
                event.preventDefault();
            }
        };
        document.addEventListener('keydown', listener);
        return () => {
            document.removeEventListener('keydown', listener);
        };
    }, [inputPassword]);

    return (
        <>
            {isOpen && (
                <div className="dialog-confirm-password dialog-confirm-password-chatbot">
                    <div className="wrapper-content">
                        <DialogTitle className="dialog-title">パスワード確認</DialogTitle>
                        <div className="dialog-content">
                            <TextField
                                name="username"
                                className="dialog-input-email"
                                type="text"
                                variant="outlined"
                                disabled={true}
                                defaultValue={inputEmail}
                                InputProps={{
                                    startAdornment: (
                                        <span className="login-item">
                                            <img src="/assets/image/people.svg" alt="" />
                                        </span>
                                    )
                                }}
                            />
                            <TextField
                                error={showError}
                                onChange={event => setInputPassword(event.target.value)}
                                className="dialog-input dialog-input-password"
                                name="password"
                                type="password"
                                variant="outlined"
                                autoFocus
                                InputProps={{
                                    startAdornment: (
                                        <span className="login-item">
                                            <img src="/assets/image/lock.svg" alt="" />
                                        </span>
                                    )
                                }}
                            />
                            {showError ? (
                                <p className="login-error" data-cy="login-form-label-error">
                                    <img src="/assets/image/error-notice.svg" alt="" />
                                    {I18n.get('COMM01MSG05')}
                                </p>
                            ) : (
                                <span className="login-error"></span>
                            )}
                        </div>
                        <div className="dialog-footer">
                            <Button className="btn-close" onClick={handleClose}>
                                キャンセル
                            </Button>
                            <Button
                                className="btn-submit"
                                onClick={handleSubmitLogin}
                                disabled={isLoadingConfirm}
                            >
                                {isLoadingConfirm ? (
                                    <span className="lds-dual-ring"></span>
                                ) : (
                                    <span>確定</span>
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
